/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { Route, Switch } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import ProjectDetailPage from 'pages/ProjectDetailPage';
import TeamPage from 'pages/TeamPage';
import ServicesPage from 'pages/ServicesPage';
import ServiceDetailPage from 'pages/ServiceDetailPage';
import SolutionsPage from 'pages/SolutionsPage';
import TechnologiesPage from 'pages/TechnologiesPage';
import CareersPage from 'pages/CareersPage';
import AboutPage from 'pages/AboutPage';
import SupportPage from 'pages/SupportPage';
import BlogPage from 'pages/BlogPage';
import BlogDetailPage from 'pages/BlogDetailPage';
import ContactPage from 'pages/ContactPage';
import DiscussProjectPage from 'pages/DiscussProjectPage';
import NotFoundPage from 'pages/NotFoundPage';

import 'assets/css/styles.css';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={LandingPage} />
      <Route exact path="/service" component={ServicesPage} />
      <Route exact path="/services" component={ServicesPage} />
      <Route exact path="/service/:service" component={ServiceDetailPage} />
      <Route exact path="/services/:service" component={ServiceDetailPage} />
      <Route exact path="/solutions" component={SolutionsPage} />
      <Route exact path="/technologies" component={TechnologiesPage} />
      <Route exact path="/case-studies" component={ProjectPage} />
      <Route exact path="/project" component={ProjectPage} />
      <Route exact path="/project/:id" component={ProjectDetailPage} />
      <Route exact path="/career" component={CareersPage} />
      <Route exact path="/careers" component={CareersPage} />
      <Route exact path="/about" component={AboutPage} />
      <Route exact path="/support" component={SupportPage} />
      <Route exact path="/blog" component={BlogPage} />
      <Route exact path="/blog/:slug" component={BlogDetailPage} />
      <Route exact path="/contact" component={ContactPage} />
      <Route exact path="/team" component={TeamPage} />
      <Route exact path="/discuss-project" component={DiscussProjectPage} />
      <Route path="" component={NotFoundPage} />
    </Switch>
  );
}

export default App;
